import React from 'react';
import { FaUsers, FaBookOpen, FaDollarSign, FaChartLine } from 'react-icons/fa';

const MetricCard = ({ icon: Icon, label, value, color, bg }) => (
    <div className={`${bg} rounded-lg p-5 flex items-center gap-4`}>
        <div className={`${color} bg-white bg-opacity-30 rounded-full p-3`}>
            <Icon size={24} />
        </div>
        <div>
            <p className='text-sm font-medium opacity-70'>{label}</p>
            <p className='text-3xl font-black'>{value}</p>
        </div>
    </div>
);

const DashboardCards = ({ datas }) => {
    const users = datas?.users || 0;
    const courses = datas?.courses || 0;
    const paid = datas?.paid || 0;
    const free = datas?.free || 0;
    const sum = datas?.sum || 0;
    const total = datas?.total || 0;
    const videoType = datas?.videoType || 0;
    const textType = datas?.textType || 0;

    const paidPercent = users > 0 ? Math.round((paid / users) * 100) : 0;
    const freePercent = users > 0 ? Math.round((free / users) * 100) : 0;
    const textPercent = courses > 0 ? Math.round((textType / courses) * 100) : 0;
    const videoPercent = courses > 0 ? Math.round((videoType / courses) * 100) : 0;

    return (
        <div className='p-6'>
            <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-8'>
                <MetricCard icon={FaUsers} label="Total Users" value={users} color="text-blue-700" bg="bg-blue-50 border border-blue-100" />
                <MetricCard icon={FaBookOpen} label="Total Courses" value={courses} color="text-purple-700" bg="bg-purple-50 border border-purple-100" />
                <MetricCard icon={FaDollarSign} label="Recurring Revenue" value={`$${sum}`} color="text-green-700" bg="bg-green-50 border border-green-100" />
                <MetricCard icon={FaChartLine} label="Total Revenue" value={`$${total}`} color="text-orange-700" bg="bg-orange-50 border border-orange-100" />
            </div>

            <div className='grid grid-cols-1 md:grid-cols-2 gap-6'>
                <div className='border rounded-lg p-5'>
                    <h3 className='font-bold text-lg mb-4'>Users</h3>
                    <div className='flex justify-between mb-1'>
                        <span className='text-sm'>Free Users</span>
                        <span className='text-sm font-bold'>{free} ({freePercent}%)</span>
                    </div>
                    <div className='w-full bg-gray-100 rounded-full h-3 mb-4'>
                        <div className='bg-gray-400 h-3 rounded-full transition-all' style={{ width: `${freePercent}%` }}></div>
                    </div>
                    <div className='flex justify-between mb-1'>
                        <span className='text-sm'>Paid Users</span>
                        <span className='text-sm font-bold'>{paid} ({paidPercent}%)</span>
                    </div>
                    <div className='w-full bg-gray-100 rounded-full h-3'>
                        <div className='bg-blue-500 h-3 rounded-full transition-all' style={{ width: `${paidPercent}%` }}></div>
                    </div>
                </div>

                <div className='border rounded-lg p-5'>
                    <h3 className='font-bold text-lg mb-4'>Courses</h3>
                    <div className='flex justify-between mb-1'>
                        <span className='text-sm'>Text Courses</span>
                        <span className='text-sm font-bold'>{textType} ({textPercent}%)</span>
                    </div>
                    <div className='w-full bg-gray-100 rounded-full h-3 mb-4'>
                        <div className='bg-purple-500 h-3 rounded-full transition-all' style={{ width: `${textPercent}%` }}></div>
                    </div>
                    <div className='flex justify-between mb-1'>
                        <span className='text-sm'>Video Courses</span>
                        <span className='text-sm font-bold'>{videoType} ({videoPercent}%)</span>
                    </div>
                    <div className='w-full bg-gray-100 rounded-full h-3'>
                        <div className='bg-orange-500 h-3 rounded-full transition-all' style={{ width: `${videoPercent}%` }}></div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DashboardCards;
